import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React from 'react';
import { ApolloProvider } from '@common/hooks';

import apollo from 'works/legacy/lib/graph-ql';
import { ErrorBoundary, sentryRouterHistory } from './legacy/lib/sentry';
import { loadIntercom } from 'works/legacy/lib/intercom';

import { AppLayout, AppSidebar, Router } from '@common/components';

import { AuthGuard } from './components/auth-guard';
import { OrganizationOnly } from './components/auth-guard/organization-only';
import { SupplierOnly } from './components/auth-guard/supplier-only';

import { AuthRoutes } from './routes/auth-routes';
import { SupplierRoutes } from './routes/supplier/supplier-routes';
import { OrganizationRoutes } from './routes/organization/organization-routes';
import { InactivityModal } from '@identity/components/inactivity-modal';
import { ChunkVersionController } from './chunk-version-controller';
import { DialogsController } from './routes/dialogs';
import {
  CurrentMembershipContextProvider,
  CurrentEntityContextProvider,
} from '@identity/contexts';

export function App() {
  loadIntercom();

  return (
    <React.StrictMode>
      <ErrorBoundary>
        <ApolloProvider client={apollo}>
          <Router history={sentryRouterHistory}>
            <ChunkVersionController />
            <AuthRoutes />
            <AuthGuard>
              <CurrentMembershipContextProvider>
                <CurrentEntityContextProvider>
                  <DialogsController />
                  <AppLayout sidebar={<AppSidebar />}>
                    <OrganizationOnly>
                      <OrganizationRoutes />
                    </OrganizationOnly>
                    <SupplierOnly>
                      <SupplierRoutes />
                    </SupplierOnly>
                  </AppLayout>
                  <InactivityModal />
                </CurrentEntityContextProvider>
              </CurrentMembershipContextProvider>
            </AuthGuard>
          </Router>
        </ApolloProvider>
      </ErrorBoundary>
    </React.StrictMode>
  );
}
